import { useState, useEffect } from 'react';
import { useDebouncedCallback } from 'beautiful-react-hooks';

type DebounceHook = <T>(value: T, delay?: number) => T;

const useDebounce: DebounceHook = (value, delay = 500) => {
  const [debouncedValue, setDebouncedValue] = useState(value);

  const updateValueDebounced = useDebouncedCallback(
    setDebouncedValue,
    [setDebouncedValue],
    delay
  );

  useEffect(() => updateValueDebounced(value), [value]);

  return debouncedValue;
};

export default useDebounce;
